const { initializeIntercom } = require('./src/utils/intercom')

exports.onRouteUpdate = () => {
  window.dataLayer.push({
    event: 'userPageView',
  })
}

exports.onInitialClientRender = () => {
  initializeIntercom()
}
